module.exports = ".embed-container {\n    text-align: center;\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0;\n    overflow: hidden;\n    max-width: 100%;\n    height: auto;\n}\n.embed-container iframe,\n.embed-container object,\n.embed-container embed {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/vimeo-modal/vimeo-modal.component.css
// module id = ./src/app/shared/components/vimeo-modal/vimeo-modal.component.css
// module chunks = main